/*
* LoginResponse return permissions:
*     * admin (boolean)
*     * capabilities (obj)
*     *     *     dpg (boolean)
*     *     *     workspace (boolean)
*     *     *     docsCreation (obj)
*     *     *     *     AI_AS (enum)
*     *     *     *     APP_AS (enum)
*     *     *     *     COVID_AS (enum)
*     *     *     *     DPIA (enum)
*     *     *     *     RISK_AS (enum)
*     *     *     *     TREAT (enum)
* This Enum map LoginResponse.permissions
* */
export enum PtPermissions {
  DPG = 'DPG',
  MANAGE_DATABREACH = 'MANAGE_DATABREACH',
  MANAGE_WORKSPACE = 'MANAGE_WORKSPACE',

  CAN_CREATE_TREAT = 'CAN_CREATE_TREAT',
  CAN_CREATE_APP_AS = 'CAN_CREATE_APP_AS',
  CAN_CREATE_COVID_AS = 'CAN_CREATE_COVID_AS',
  CAN_CREATE_AI_AS = 'CAN_CREATE_AI_AS',
  CAN_CREATE_DATABREACH = 'CAN_CREATE_DATABREACH',


  FORCE_TO_DISABLED = 'FORCE_TO_DISABLED', //flag used to disable UI side elements
  ENABLE_FOR_ADMIN = 'ENABLE_FOR_ADMIN', //flag used to enable UI side elements for admin user
  ENABLE_FOR_SYSTEM = 'ENABLE_FOR_SYSTEM', //flag used to enable UI side elements for system user


  // MODULE
  ACTIVE_MODULE_AI = 'ACTIVE_MODULE_AI',
  ACTIVE_MODULE_COVID = 'ACTIVE_MODULE_COVID',
  ACTIVE_MODULE_CYBERSEC = 'ACTIVE_MODULE_CYBERSEC',
  ACTIVE_MODULE_DATABREACH = 'ACTIVE_MODULE_DATABREACH',
  ACTIVE_MODULE_LIA = 'ACTIVE_MODULE_LIA',

}
